import React, { useState, useRef, useEffect } from 'react';

import DigitalSuccessRoom from './digitalsuccessroom';
import DigitalSuccessRoomEditAccess from './digitalsuccessroomeditaccess';
import DigitalSuccessRoomViewAccess from './digitalsuccessroomviewaccess';
import AccessDenied from './accessdenied'
import { useParams } from 'react-router-dom'
import axios from "axios";
import custom_api_func from './axios_api_func';
import custom_api_func2 from './axios_api_func_2';
import LoadingScreen from './loadingscreen';

const DigitalSuccessRoomRedirector = () => {
  var { tokenid } = useParams()

  useEffect(()=>{
  localStorage.setItem('dsrtokenid',tokenid)
  localStorage.setItem('user_name','N/A')
   },[])
  
  const [accesslevel,setaccesslevel] = useState('null')
  const [loading,setloading] = useState(true)
  
  useEffect(()=>{
  if (tokenid){
    custom_api_func2.get(`https://api.successguardian.in/api/dsr_get_userdetails/${tokenid}`).then((response) => {
          if (response.data.accesslevel){
        setaccesslevel(response.data.accesslevel)
          }
        localStorage.setItem('user_name',response.data.username)
        localStorage.setItem('accesslevel',response.data.accesslevel)
        setloading(false)
      }).catch ((error)  => {
        setaccesslevel(null)
        setloading(false)})
  }

  },[])
  

  return (
    <>
    {accesslevel.toLowerCase()==='view'  && (!loading) && (
      <DigitalSuccessRoomViewAccess />
  )}

  {accesslevel.toLowerCase()==='edit'  && (!loading) && (
      <DigitalSuccessRoomEditAccess />
  )}

  {accesslevel.toLowerCase()==='internal'  && (!loading) && (
      <DigitalSuccessRoom />
  )}

  {accesslevel.toLowerCase()==='null' && (!loading) && (
      <AccessDenied />
  )}

 {loading && (
     <div style={{ 
              display: 'flex',
              justifyContent: 'center',
              
              alignItems: 'center',
              height: '300px',
              width: '100%'
            }}>
              <LoadingScreen loading={true} />
            </div>
 )}

  </>
  )
}

export default DigitalSuccessRoomRedirector;